import { lazy } from 'react';
import { FuseRouteItemType } from '@fuse/utils/FuseUtils';

const BillingTransactionsPage = lazy(() => import('./BillingTransactionsPage'));
const path = 'reports/billing/transactions';

const BillingTransactionsRoute: FuseRouteItemType = {
	path: path,
	element: <BillingTransactionsPage />,
	settings: {
		layout: {
			config: {
				navbar: {
					display: true
				},
				toolbar: {
					title: 'Transaction History',
					showCrumbs: false,
					helpName: 'Billing Transactions'
				},
				footer: {
					display: false
				},
				leftSidePanel: {
					display: false
				},
				rightSidePanel: {
					display: false
				}
			}
		}
	}
};

export default BillingTransactionsRoute;
